
import { Inject } from 'inversify-props'
import type { MetaDiariaServiceAdapter } from './adapter'
import { MetaDiaria } from '@/models/MetaDiaria'


export class FindMetaDiariaUseCase {
	@Inject('MetaDiariaServiceAdapter')
	private metaService!: MetaDiariaServiceAdapter


	findById = async (id: string): Promise<MetaDiaria> => 
		await this.metaService.get(id)

	findByUserAndRange = async (metaId: string, userId: string, start: string, end: string): Promise<MetaDiaria[]> => 
		await this.metaService.findByUserAndRange(metaId, userId, start, end)

	getValorTotalMetasDiarias = async (metaId: string, start: string, end: string): Promise<number> =>
		await this.metaService.getValorTotalMetasDiarias(metaId, start, end)
	
}